import {
    createContext,
} from 'react'

const SharedContext = createContext({})

export default SharedContext
